type BrowsingContextSuggestionsResponse = {
  detected_values?: {
    country?: {
      handle?: string;
    };
  };
};

// Shopify's own geolocation endpoint (backs the native Markets store-recommendation
// popup). Same-origin, no CORS/auth needed. Returns null on any failure - including
// a rejected fetch (endpoint unreachable, blocked by the client) - so callers never
// need to distinguish "visitor not detected" from "request failed".
export const detectVisitorCountryCode = async (): Promise<string | null> => {
  try {
    const response = await fetch('/browsing_context_suggestions.json');

    if (!response.ok) {
      return null;
    }

    const data: BrowsingContextSuggestionsResponse = await response.json();
    return data.detected_values?.country?.handle ?? null;
  } catch {
    return null;
  }
};
